import React from "react";
import PropTypes from "prop-types";
import {makeStyles, Typography} from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    typography: {
        fontSize: '14px',
        paddingLeft: '10px',
        color: theme.palette.secondary.dark
    }
}));
export default function CharacterCounter (props) {
    const classes = useStyles();

    const {
        characterQuantityMax,
        value
    } = props;

    return (
        <Typography className={classes.typography}>
            {characterQuantityMax - (value ? value.length : 0)} caracteres restantes.
        </Typography>
    );
}

CharacterCounter.propTypes = {
    characterQuantityMax: PropTypes.number.isRequired,
    value: PropTypes.string
};